import axios from './../../config/axios';

function create(data) {
    return axios().post("/stock-journal/stock-transfers", data);
}

function find(id) {
    return axios().get(`/stock-journal/stock-transfers/${id}`);
}

function remove(id) {
    return axios().delete(`/stock-journal/stock-transfers/${id}`);
}

function update(data) {
    return axios().put(`/stock-journal/stock-transfers/${data.id}`, data)
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get(`/stock-journal/stock-transfers`, {
        params
    })
}

function print(id) {
    console.log(id)
    return new Promise(resolve => {
        setTimeout(() => {
            resolve({
                data: `
                    <html>
                        <body>
                            <h1>Stock Transfer Print Page</h1>
                        </body>
                    </html>
                ` 
            })
        }, 300)
    })
}

function post(id) {
    return axios().put(`/stock-journal/stock-transfers/${id}/post`, {});
}

export default {
    create,
    find,
    remove,
    update,
    index,
    print,
    post
}